import { Component } from '@angular/core';

@Component({
  selector: 'bashgo-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'bashgo';
}
